// src/data/galleryData.js

// Este archivo gestiona las imágenes para la galería principal del hotel.
const galleryData = [
  {
    id: 1,
    url: 'https://res.cloudinary.com/dgn1mpqsc/image/upload/v1751675248/DSC04614_jv5dsd.jpg',
    alt: 'Fachada del Hotel Fontana Bogotá',
  },
  {
    id: 2,
    url: 'https://res.cloudinary.com/dgn1mpqsc/image/upload/v1751675244/DSC04583_fuknac.jpg',
    alt: 'Restaurante del hotel',
  },
  {
    id: 3,
    url: 'https://res.cloudinary.com/dgn1mpqsc/image/upload/v1751675242/DSC04571_idqm8r.jpg',
    alt: 'Sala de juntas equipada',
  },
  {
    id: 4,
    url: 'https://res.cloudinary.com/dgn1mpqsc/image/upload/v1751675213/DSC04550_o9tpwl.jpg',
    alt: 'restaurante del hotel',
  },
  {
    id: 5,
    url: 'https://res.cloudinary.com/dgn1mpqsc/image/upload/v1751675210/DSC04544_sxms3g.jpg',
    alt: 'Lobby y área de recepción',
  },
  {
    id: 6,
    url: 'https://res.cloudinary.com/dgn1mpqsc/image/upload/v1751675245/DSC04600_czjgjf.jpg',
    alt: 'Detalle del área de desayuno',
  },
  {
    id: 7,
    url: 'https://res.cloudinary.com/dgn1mpqsc/image/upload/v1751675209/DSC04340_revdvk.jpg',
    alt: 'Detalle del área de desayuno',
  },
  {
    id: 8,
    url: 'https://res.cloudinary.com/dgn1mpqsc/image/upload/v1751680951/WhatsApp_Image_2025-07-04_at_9.02.07_PM_vhagwz.jpg',
    alt: 'Detalle del área de desayuno',
  },
];

export default galleryData;
